import React from 'react';

export default function WhatsAppFloat() {
  return (
    <a 
      href="https://api.whatsapp.com/send?phone=919876543210&text=Hi!%20I%20have%20an%20enquiry." 
      class="whatsapp-float" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i class="fab fa-whatsapp"></i>
    </a>
  );
}
